export default new Promise(() => {
  const hubSpotAnalyticsScript = document.createElement("script");
  hubSpotAnalyticsScript.setAttribute(
    "src",
    "//js.hs-scripts.com/2480573.js?businessUnitId=1146179"
  );
  document.head.appendChild(hubSpotAnalyticsScript);
});
